<script>
  import ImageInput from "./ImageInput.svelte";
  import ContenteditableInput from "./ContenteditableInput.svelte";
  import TextInput from "./TextInput.svelte";
  import CopyTextField from "./CopyTextField.svelte";

  import { profile } from "#src/stores/auth.js";

  export let edge;

  $: multiple = Array.isArray(edge.id);
</script>

<div class="text-xs px-4">
  {#if !multiple}
    <ImageInput
      label="Image"
      labelWidth="5rem"
      value={`/images/${edge.image?.filename}`}
      accept="image/png, image/svg+xml"
      uploadType="arraybuffer"
      disabled />
  {/if}
  <ContenteditableInput label="Name" disabled labelWidth="5rem" value={edge.name} />
  <TextInput label="Classification" disabled labelWidth="5rem" value={edge.classification} />
  {#if $profile?.user_role === "developer" && !multiple}
    <CopyTextField label="ID" labelWidth="5rem" value={edge.id} />
  {/if}
</div>
